import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { GlobalNavItem as GlobalNavItemSDS } from '@snapchat/snap-design-system-marketing';
import type { FC } from 'react';
import { useContext } from 'react';

import { ElementLocation } from '../../../../context/ElementLocationContext/ElementLocationContext';
import { shouldFlushLogs } from '../../../../helpers/getLocalPath';
import { logger, logUserEvent } from '../../../../helpers/logging';
import { UserAction } from '../../../../types/events';
import { itemListCss, itemsWrapperCss, listItemCss } from './SideMenu.styles';
import type { SideMenuDataItemProps } from './types';

export const SideMenu: FC<{ navItems: SideMenuDataItemProps[] }> = ({ navItems }) => {
  const elementLocation = useContext(ElementLocation).elementLocation;

  const logSideMenuClick = (url: string, title: string) => {
    logUserEvent({
      eventCategory: 'SnapSideMenu',
      eventAction: UserAction.Click,
      eventLabel: `to: ${url}`,
      context: { targetUrl: url, elementText: title, elementLocation },
    });

    if (shouldFlushLogs(url)) {
      void logger.flush();
    }
  };

  return (
    <nav className={itemsWrapperCss}>
      <ol className={itemListCss}>
        {navItems?.map((item, index) => (
          <li key={`list-item-${index}`} className={listItemCss}>
            <GlobalNavItemSDS
              title={documentToPlainTextString(item?.title?.json)}
              href={item.url}
              onClick={() =>
                logSideMenuClick(item.url, documentToPlainTextString(item?.title?.json))
              }
            />
          </li>
        ))}
      </ol>
    </nav>
  );
};
